
angular.module('taric.measure.ccrm', ['common.model.geoarea', 'common.model.measuretype', 'common.template.geoarea.popup', 'taric.model.measure',
        'common.template.measure.popup', 'common.template.additional-code.popup',
        'common.template.condition.popup', 'taric.model.footnote', 'common.template.footnote.popup',
        'common.helper', 'common.filter.measuretype.description',
        'common.filter.geographicalarea.description', 'common.filter.truncateLongText',
        'common.directive.country', 'taric.auth.model', 'common.filter.dutyexpression.description'])

    .controller('SearchMeasuresByCCController', function (CONSTANTS, $translatePartialLoader, MeasureTypeModel, MeasureByCCSearchModel, $uibModal, GeographicalAreaModel, $state, CommonHelper, measureTypes, $filter, $translate, $rootScope, $scope, AuthorizeModel, $timeout, $stateParams, countries, $location) {
        var searchMeasuresByCCCtrl = this;
        var model = MeasureByCCSearchModel;
        searchMeasuresByCCCtrl.init = function () {
            searchMeasuresByCCCtrl.searchCriteria = MeasureByCCSearchModel.getSearchCriteria();
            searchMeasuresByCCCtrl.installationCountry = CONSTANTS.installationCountry;
            searchMeasuresByCCCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            searchMeasuresByCCCtrl.dateFormat = CONSTANTS.dateFormat;
            searchMeasuresByCCCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
            searchMeasuresByCCCtrl.searchMeasureResult = MeasureByCCSearchModel.getSearchMeasureResult();
            searchMeasuresByCCCtrl.measureTypes = measureTypes;
            searchMeasuresByCCCtrl.controlCountry = {};
            searchMeasuresByCCCtrl.releaseManagement = CONSTANTS.releaseManagement;

            // get valid MeasureType
            if (measureTypes) {
                searchMeasuresByCCCtrl.searchCriteria.measureType = CommonHelper.getValidSelectedItem(
                    measureTypes.items,
                    searchMeasuresByCCCtrl.searchCriteria.measureType,
                    null);
            }

            searchMeasuresByCCCtrl.model = MeasureByCCSearchModel;
            searchMeasuresByCCCtrl.model.loggedIn = AuthorizeModel.loggedIn;
            if (CONSTANTS.releaseManagement && AuthorizeModel.loggedIn && AuthorizeModel.isIncludedUnreleasedDataViewer()) {
                searchMeasuresByCCCtrl.model.includeUnreleased = true;
                searchMeasuresByCCCtrl.showIncludeUnreleased = true;
            } else {
                searchMeasuresByCCCtrl.model.includeUnreleased = false;
                searchMeasuresByCCCtrl.showIncludeUnreleased = false;
            }

            if (searchMeasuresByCCCtrl.isExternalLink() && searchMeasuresByCCCtrl.validateExternalParameters()) {
                if (countries){

                    // get valid CountryCode
                    searchMeasuresByCCCtrl.searchCriteria.country = CommonHelper.getValidSelectedItem(
                        countries.items,
                        searchMeasuresByCCCtrl.searchCriteria.country,
                        null);
                }

                // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
                searchMeasuresByCCCtrl.loadDataFromServerWithoutValidation(1);
            }
        };

        searchMeasuresByCCCtrl.isExternalLink = function(){
            return (!$stateParams.frm || ($stateParams.frm !== 'ccLookup' && $stateParams.frm !== 'ccView')) && $stateParams.sd && $stateParams.cc;
        };

        //Check whether the external parameters are valid or not
        searchMeasuresByCCCtrl.validateExternalParameters = function(){
            searchMeasuresByCCCtrl.resetError();
            return !searchMeasuresByCCCtrl.isCommodityTooShort() &&
                searchMeasuresByCCCtrl.validateCommodityCode() &&
                searchMeasuresByCCCtrl.validateSimulationDate();
        };

        searchMeasuresByCCCtrl.openDatePicker = function ($event) {
            searchMeasuresByCCCtrl.isDatePickerOpen = true;
        };

        searchMeasuresByCCCtrl.onDateChange = function (dateString) {
            searchMeasuresByCCCtrl.resetError();
            searchMeasuresByCCCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(searchMeasuresByCCCtrl.searchCriteria.simulationDate, dateString);
            if (searchMeasuresByCCCtrl.searchCriteria.simulationDate){
                searchMeasuresByCCCtrl.loadingReferenceData = true;
                searchMeasuresByCCCtrl.controlCountry.reload(searchMeasuresByCCCtrl.searchCriteria.simulationDate).then(() => {
                    searchMeasuresByCCCtrl.loadingReferenceData = false;
                }, function (error) {
                    searchMeasuresByCCCtrl.errorCode = error.data.code;
                    searchMeasuresByCCCtrl.errorParams = error.data.params;
                    searchMeasuresByCCCtrl.errorType = error.data.type;
                    searchMeasuresByCCCtrl.loadingReferenceData = false;
                });

                searchMeasuresByCCCtrl.reloadMeasureTypes();
            }
        };

        searchMeasuresByCCCtrl.reloadMeasureTypes = function () {
            MeasureTypeModel.getMeasureTypes(searchMeasuresByCCCtrl.searchCriteria.direction, searchMeasuresByCCCtrl.searchCriteria.simulationDate).then(function (measureTypes) {
                searchMeasuresByCCCtrl.measureTypes = measureTypes;

                searchMeasuresByCCCtrl.searchCriteria.measureType = CommonHelper.getValidSelectedItem(
                    measureTypes.items,
                    searchMeasuresByCCCtrl.searchCriteria.measureType,
                    null);
            });
        };

        searchMeasuresByCCCtrl.search = function () {
            //Load data for the first page
            searchMeasuresByCCCtrl.loadDataFromServer(1);
        };

        //Load data for a given page
        searchMeasuresByCCCtrl.loadDataFromServer = function (pageNumber) {
            if (!searchMeasuresByCCCtrl.validateSearchForm()){
                return;
            }

            searchMeasuresByCCCtrl.loadDataFromServerWithoutValidation(pageNumber);
        };

        //Load data for a given page without validation
        searchMeasuresByCCCtrl.loadDataFromServerWithoutValidation = function (pageNumber) {
            // Reset search result before searching
            searchMeasuresByCCCtrl.resetSearchResult();
            searchMeasuresByCCCtrl.searching = true;
            MeasureByCCSearchModel.searchMeasure(pageNumber).then(function (searchMeasureResult) {
                searchMeasuresByCCCtrl.searchMeasureResult = searchMeasureResult;
                searchMeasuresByCCCtrl.searching = false;

                searchMeasuresByCCCtrl.searchMeasureResult.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(searchMeasuresByCCCtrl.searchCriteria.simulationDate);
                if (searchMeasuresByCCCtrl.searchMeasureResult.infoCode &&
                    "i8n.common.pastDate" === searchMeasuresByCCCtrl.searchMeasureResult.infoCode) {
                    searchMeasuresByCCCtrl.searchMeasureResult.infoParams = CONSTANTS.pastDate;
                }

                searchMeasuresByCCCtrl.updateBrowserURL();
            }, function (error) {
                searchMeasuresByCCCtrl.errorCode = error.data.code;
                searchMeasuresByCCCtrl.errorParams = error.data.params;
                searchMeasuresByCCCtrl.errorType = error.data.type;
                searchMeasuresByCCCtrl.searching = false;

                if (searchMeasuresByCCCtrl.errorCode === 'i8n.bl.unauthenticated') {
                    $rootScope.$broadcast('tokenInvalid');
                }
            });
        };

        /**
         * Query measures by commodity codes
         * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/measure/ccrm/search?sd={SimulationDate}&d={TradeDirection}&cc={CommodityCode}&mt={MeasureType}&co={Country}&l={Language}
         *
         * Example:
         * http://www.testenv.se/arctictariff-public-web/#!/taric/measure/ccrm/search?sd=2015-01-01&d=I&cc=1005109000&mt=103&co=US&l=en
         */
        searchMeasuresByCCCtrl.updateBrowserURL = function(){
            if (!CONSTANTS.enableBookmark){
                return;
            }

            // Do not keep additional parameters because there is no return to caller page
            $location.search({
                sd: CommonHelper.getBookmarkDateString(searchMeasuresByCCCtrl.searchCriteria.simulationDate),
                d : searchMeasuresByCCCtrl.searchCriteria.direction,
                cc: CommonHelper.removeSpaceCharacters(searchMeasuresByCCCtrl.searchCriteria.commodityCode),
                mt: searchMeasuresByCCCtrl.searchCriteria.measureType,
                co: searchMeasuresByCCCtrl.searchCriteria.country,
                l : $translate.use()
            }).replace();
        };

        $rootScope.$on('clearSearchResult', function (event, data) {

            // If token has become invalid
            model.reset();
            searchMeasuresByCCCtrl.searchCriteria = model.getSearchCriteria();
            searchMeasuresByCCCtrl.controlCountry.reload(searchMeasuresByCCCtrl.searchCriteria.simulationDate);
            searchMeasuresByCCCtrl.reloadMeasureTypes();
        });

        searchMeasuresByCCCtrl.resetSearchResult = function() {
            searchMeasuresByCCCtrl.searchMeasureResult = null;
            MeasureByCCSearchModel.resetSearchResult();
        };

        //Handle page change for the measure search result table
        searchMeasuresByCCCtrl.searchMeasureResultPageChanged = function (pageNumber) {
            searchMeasuresByCCCtrl.loadDataFromServer(pageNumber);
        };

        //Check whether the search form is valid or not
        searchMeasuresByCCCtrl.validateSearchForm = function(){
            searchMeasuresByCCCtrl.resetError();
            return !searchMeasuresByCCCtrl.isCommodityTooShort() &&
                searchMeasuresByCCCtrl.validateCommodityCode() &&
                searchMeasuresByCCCtrl.validateCountryCode() &&
                searchMeasuresByCCCtrl.validateSimulationDate();
        };

        searchMeasuresByCCCtrl.validateCountryCode = function(){
            searchMeasuresByCCCtrl.errorCode = searchMeasuresByCCCtrl.controlCountry.validate();
            return searchMeasuresByCCCtrl.errorCode === null;
        };

        searchMeasuresByCCCtrl.validateCommodityCode = function () {
            searchMeasuresByCCCtrl.errorCode = CommonHelper.validateCommodityCode(searchMeasuresByCCCtrl.searchCriteria.commodityCode, searchMeasuresByCCCtrl.searchCriteria.direction);
            return searchMeasuresByCCCtrl.errorCode === null;
        };

        searchMeasuresByCCCtrl.validateSimulationDate = function () {
            if (!CONSTANTS.dateRestrictionEnabled) {
                searchMeasuresByCCCtrl.errorCode = CommonHelper.validateSimulationDate(searchMeasuresByCCCtrl.searchCriteria.simulationDate);
                if (searchMeasuresByCCCtrl.errorCode){
                    searchMeasuresByCCCtrl.errorParams = {param0: CONSTANTS.pastDate};
                }
            }
            return searchMeasuresByCCCtrl.errorCode === null;
        };

        searchMeasuresByCCCtrl.isCommodityTooShort = function () {
            if (!searchMeasuresByCCCtrl.searchCriteria.commodityCode || CommonHelper.removeSpaceCharacters(searchMeasuresByCCCtrl.searchCriteria.commodityCode).length < 4) {
                searchMeasuresByCCCtrl.errorCode = 'i8n.jsfconv.cc.atleast4';
                return true;
            }
            return false;
        };

        searchMeasuresByCCCtrl.openOriginPopup = function (size, origin) {
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/geo-area/geoarea-popup.tmpl.html',
                controller: 'GeographicalAreaPopupController as geoAreaPopupCtrl',
                size: size,
                resolve: {
                    geoAreaMemberships: function () {
                        return GeographicalAreaModel.queryMembershipByGroupId(origin, searchMeasuresByCCCtrl.searchCriteria.simulationDate);
                    },
                    origin: function () {
                        return origin;
                    }
                }
            });
        };

        searchMeasuresByCCCtrl.openMeasurePopup = function (size, measure) {
            var preferenceCodesForMeasureOnly = true;
            var selectedPreferenceCode = null;
            // In this case additional code array can be empty, only using measure SID in query
            var additionalCodes = [];
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/measure/measure-popup.tmpl.html',
                controller: 'MeasurePopupController as measurePopupCtrl',
                size: size,
                resolve: {
                    measureExtendedInfo: function (MeasurePopupModel) {
                        return MeasurePopupModel.getMeasureExtendedInfoForMeasureType(measure.sid, preferenceCodesForMeasureOnly, searchMeasuresByCCCtrl.searchCriteria.commodityCode,
                            searchMeasuresByCCCtrl.searchCriteria.country, searchMeasuresByCCCtrl.searchCriteria.direction, selectedPreferenceCode, additionalCodes, searchMeasuresByCCCtrl.searchCriteria.simulationDate, null, measure.unreleased);
                    }
                }
            });
        };

        searchMeasuresByCCCtrl.openConditionPopup = function (size, measure) {
            var monetaryUnitCode = 'EUR';
            // In this case additional code array can be empty, only using measure SID in query
            var additionalCodes = [];
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/condition/condition-popup.tmpl.html',
                controller: 'ConditionPopupController as conditionPopupCtrl',
                size: size,
                resolve: {
                    measureConditionHeadResult: function (ConditionPopupModel) {
                        return ConditionPopupModel.getMeasureExtendedInfoForMeasureConditions(measure.sid, monetaryUnitCode, additionalCodes, searchMeasuresByCCCtrl.searchCriteria.simulationDate, searchMeasuresByCCCtrl.searchCriteria.direction, measure.unreleased).then(function(measureCondition){
                            var result = {count: 1};
                            var items = [];
                            items.push(measureCondition);
                            result.items = items;
                            return result;
                        });
                    }
                }
            });
        };

        searchMeasuresByCCCtrl.openFootnotePopup = function (size, footnoteId) {
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/footnote/footnote-popup.tmpl.html',
                controller: 'FootnotePopupController as footnotePopupCtrl',
                size: size,
                resolve: {
                    footnote: function (FootnotePopupModel) {
                        return FootnotePopupModel.findFootnote(footnoteId, searchMeasuresByCCCtrl.searchCriteria.simulationDate);
                    }
                }
            });
        };

        searchMeasuresByCCCtrl.openAdditionalCodePopup = function (size, additionalCodeId, commodityCode) {
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/additional-code/additional-code-popup.tmpl.html',
                controller: 'AdditionalCodePopupController as additionalCodePopupCtrl',
                size: size,
                resolve: {
                    additionalCode: function (AdditionalCodePopupModel) {
                        return AdditionalCodePopupModel.findAdditionalCode(additionalCodeId, searchMeasuresByCCCtrl.searchCriteria.simulationDate, commodityCode);
                    },
                    simulationDate: function () {
                        return searchMeasuresByCCCtrl.searchCriteria.simulationDate;
                    }
                }
            });
        };

        searchMeasuresByCCCtrl.openQuotaPopup = function (size, measure) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/quota/quota-popup.tmpl.html',
                controller: 'ViewTaricQuotaController as viewTaricQuotaCtrl',
                size: size,
                resolve: {
                    quotaDefinitionExtendedInfo: function (TaricQuotaSearchModel) {

                        var inputOrigin = measure.geographicalArea.id;
                        if (searchMeasuresByCCCtrl.searchCriteria.country !== " " && searchMeasuresByCCCtrl.searchCriteria.country) {
                            inputOrigin = searchMeasuresByCCCtrl.searchCriteria.country;
                        }

                        var quotaExtendedInfo = TaricQuotaSearchModel.getQuotaDefinitionExtendedInfo(measure.orderNumber, inputOrigin, searchMeasuresByCCCtrl.searchCriteria.simulationDate).then(function (quotaExtendedInfo) {
                            return quotaExtendedInfo;
                        }, function (error) {
                            searchMeasuresByCCCtrl.errorCode = error.data.code;
                            searchMeasuresByCCCtrl.errorParams = error.data.params;
                            searchMeasuresByCCCtrl.errorType = error.data.type;
                            return;
                        });

                        return quotaExtendedInfo;
                    },
                    simulationDate: function () {
                        return searchMeasuresByCCCtrl.searchCriteria.simulationDate;
                    },
                    showCancelButton: function () {
                        return false;
                    },
                    country: function (){
                        return searchMeasuresByCCCtrl.searchCriteria.country;
                    }
                }
            });
        };

        searchMeasuresByCCCtrl.selectCommodityCode = function (commodityCode, type) {

            $state.go('taric.nomenclature.sbn', {
                cc: CommonHelper.removeSpaceCharacters(commodityCode),
                sd: CommonHelper.getBookmarkDateString(searchMeasuresByCCCtrl.searchCriteria.simulationDate),
                d: searchMeasuresByCCCtrl.searchCriteria.direction, frm: 'taric.measure.ccrm', type: type
            });
        };

        searchMeasuresByCCCtrl.resetError = function(){
            searchMeasuresByCCCtrl.handleError(null);
        };

        searchMeasuresByCCCtrl.hasNationalMeasureTypes = function(){
            var nationalMeasureTypes = searchMeasuresByCCCtrl.measureTypes.items.filter(function(measureType){
                return measureType.national === true;
            });
            return nationalMeasureTypes.length > 0;
        };

        searchMeasuresByCCCtrl.isTooltipEnable = function(descriptions){
            return CommonHelper.isTooltipEnable(descriptions);
        };

        searchMeasuresByCCCtrl.formatCommodityCode = function(){
            var formattedCommodityCode = $filter('commodityCode')(searchMeasuresByCCCtrl.searchCriteria.commodityCode);
            searchMeasuresByCCCtrl.searchCriteria.commodityCode = formattedCommodityCode;
        };


        searchMeasuresByCCCtrl.handleError = function(error){
            if(!error){
                searchMeasuresByCCCtrl.errorCode = null;
                searchMeasuresByCCCtrl.errorParams = null;
            } else {
                searchMeasuresByCCCtrl.errorCode = error.errorCode;
                searchMeasuresByCCCtrl.errorParams = error.errorParams;
            }
        };

        searchMeasuresByCCCtrl.onCountryChange = function(country){
            searchMeasuresByCCCtrl.searchCriteria.country = country;
        };

        searchMeasuresByCCCtrl.print = function(options) {
        	
        	if (!searchMeasuresByCCCtrl.validateSearchForm()){
                $scope.$apply();
                return;
            }

          	$rootScope.$broadcast('startSpinningPrint');
          	MeasureByCCSearchModel.searchMeasure().then(function (searchMeasureResult){
            	
          		searchMeasuresByCCCtrl.searchMeasureAllResult = searchMeasureResult;
            	setTimeout(function(){

                    // load documents
                    var doc = [];
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                    CommonHelper.printPlainDocument({
                        contents: doc,
                        logo: options.logo,
                        flag: searchMeasuresByCCCtrl.flagImg,
                        eu: searchMeasuresByCCCtrl.euImg,
                        validDate: $filter('date')(searchMeasuresByCCCtrl.searchCriteria.simulationDate, CONSTANTS.dateFormat),
                        title: $filter('translate')('i8n.qry.ccrm.report.report.title')
                    }, 'l').then(() => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    }, (error) => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    });

                }, 1000);
            }, function (error) {
                searchMeasuresByCCCtrl.errorCode = error.data.code;
                searchMeasuresByCCCtrl.errorParams = error.data.params;
                searchMeasuresByCCCtrl.errorType = error.data.type;
              	$rootScope.$broadcast('stopSpinningPrint');

                if (searchMeasuresByCCCtrl.errorCode === 'i8n.bl.unauthenticated') {
                    $rootScope.$broadcast('tokenInvalid');
                }
            });
        };

    	$scope.$on('printDocument', function(event, data) {

            CommonHelper.loadImage("img/flags/EU.png", 21, 14, function(options) {

                searchMeasuresByCCCtrl.euImg = options.logo;
            }, true);
    		
    		var url = "img/flags/" + searchMeasuresByCCCtrl.installationCountry + ".png";
    		CommonHelper.loadImage(url, 21, 14, function(options) {
    			
    			searchMeasuresByCCCtrl.flagImg = options.logo;
        		CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, searchMeasuresByCCCtrl.print, true);
    		}, true);
        });

        $rootScope.$on('$translateChangeSuccess', function () {

            //This is just a workaround to force the page to re-render the pagination items with translated texts
            searchMeasuresByCCCtrl.itemsPerPage = 99999999;
            $timeout(function(){
                searchMeasuresByCCCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            }, 100);
        });
    });


// WEBPACK FOOTER //
// ./app/taric/measure/ccrm/measure-ccrm.js